import React, { FC, useState } from "react";
import moment from "moment";
import { NavLink } from "react-router";

import { useThemingPrefix } from "hooks/useThemingPrefix";

import Icon from "../ui/icons/icon";
import { Button, CircleCounter, Modal, Tag } from "../ui";
import { Package } from "../../models/package.type";
import { Attraction } from "../../models/attraction.type";
import { TagVariant } from "../ui/tag";
import { useGetParkQuery } from "../../store/api/park.api";
import { FilePreview } from "../index";
import useHumanTimeLocale from "../../hooks/use-human-time-locale";
import { getRoute, pages } from "../../utils/routrer-utils";
import useFileTypeQualifier from "../../hooks/use-file-type-qualifier";

import VideoImage from "../../resources/images/video.png";
import Video360Image from "../../resources/images/video-360.png";
import PhotoImage from "../../resources/images/photo.png";

import styles from "./index.module.css";

type MediaPackProps = {
  pack: Package;
  attraction: Attraction;
  ticketNumber: string;
  ticketPrefix: string;
  isProcessing?: boolean;
};

const MediaPack: FC<MediaPackProps> = (props) => {
  const { pack, attraction, isProcessing } = props;
  const [openPreview, setOpenPreview] = useState<boolean>(false);
  const park = useGetParkQuery(attraction.park_id);
  const dayLimit = 30;
  const humanTime = useHumanTimeLocale();
  const dayOffset = moment().diff(moment(pack.date_time_creation), "days");
  const firstFile = pack.package_items[0].file_link;
  const vendorThemingPrefix = useThemingPrefix();
  const qualifier = useFileTypeQualifier();

  let imagePath;
  if (qualifier.isVideo(firstFile)) {
    if (firstFile.includes(".360.")) {
      imagePath = Video360Image;
    } else {
      imagePath = VideoImage;
    }
  } else {
    imagePath = PhotoImage;
  }

  return (
    <div
      className={`${styles.container} ${
        props.ticketNumber ? styles.hasTicketNumber : ""
      }`}
    >
      <div
        className={styles.previewContainer}
        onClick={isProcessing ? undefined : setOpenPreview.bind(null, true)}
      >
        <img src={imagePath} alt="" className={styles.previewImage} />
        <div className={styles.previewOverlay}>
          <div className={styles.previewPlayIcon}>
            <Icon name="Play" size={35} />
          </div>
        </div>
        {props.isProcessing && (
          <div className={styles.processingOverlay}>
            <div className={styles.processingText}>
              «Ваше видео обрабатывается
              <br />
              и появится здесь в течение
              <br />
              24 часов после проката»
            </div>
          </div>
        )}
      </div>
      <div className={styles.content}>
        {isProcessing && <div className={styles.contentProcessingCover} />}
        <div className={styles.tagContainer}>
          <Tag variant={pack.status as TagVariant} />
        </div>
        <h1 className={styles.title}>{attraction.name}</h1>
        <div className={styles.parkName}>{park.data?.name}</div>
        <div className={styles.mediaCode}>
          Код медиафайла: {props.ticketNumber}
        </div>
        <div className={styles.date}>
          {humanTime.dateMDY(pack.date_time_creation)}
        </div>
        <div className={styles.counterContainer}>
          <CircleCounter offset={dayOffset} limit={dayLimit} />
          <span className={styles.counterText}>
            {humanTime.days(dayLimit - dayOffset)} до удаления
          </span>
        </div>
        <div className={styles.downloadButtonContainer}>
          <NavLink
            to={getRoute(`${pages.FILES}/${pack.id}`, vendorThemingPrefix)}
          >
            <Button
              label="Просмотреть весь медиапакет"
              variant="fill"
              padding={28}
              isFullWidth
            />
          </NavLink>
        </div>
      </div>
      <Modal isShow={openPreview} onShow={setOpenPreview} width={1024}>
        <FilePreview files={pack.package_items} pack={pack} />
      </Modal>
    </div>
  );
};

export default MediaPack;
